import React from 'react'

import {
  Icon as LibraryIcon,
  mediaQueries,
  palette,
} from '@centivo/react-components'
import { useMediaContext } from 'src/context/responsive'
import styled, { useTheme } from 'styled-components'

const SearchBarButtonTag = styled.button<{ backgroundColor: string }>`
  background-color: #f7f4e6;
  border-radius: 0.625rem;
  border: 1px ${palette.brand.darkGreen} solid;
  width: 210px;
  height: 150px;
  position: relative;
  cursor: pointer;
  color: ${({ backgroundColor }) =>
    backgroundColor === 'green'
      ? palette.brand.lightGreen
      : palette.brand.darkGreen};

  &:not(:last-child) {
    margin-right: 0.625rem;

    @media ${mediaQueries.desktop} {
      margin-right: 1.25rem;
    }
  }

  span {
    align-items: center;
    display: flex;
    font-size: 1.125rem;
    font-weight: 600;
    justify-content: center;
    margin-top: 1.25rem;
    svg {
      margin: 0px 0px 0px 0.85rem;
    }
  }

  &.selected {
    background-color: ${palette.brand.darkGreen};
    color: ${({ theme }) => theme.palette.brand.lightGreen};
    svg {
      color: ${({ theme }) => theme.palette.brand.lightGreen};
    }
  }

  &:focus {
    border-width: 0;
    box-shadow: 0px 0px 0px 6px ${({ theme }) => theme.palette.brand.newPurple};
    outline: 3px solid white;
  }
`

interface SearchBarButtonProps
  extends Pick<React.HTMLProps<HTMLButtonElement>, 'onClick'> {
  selected: boolean
  icon: React.ReactElement
  title: string
  backgroundColor?: string
}

export const SearchBarButtonDefault: React.FC<SearchBarButtonProps> = ({
  selected,
  icon,
  title,
  onClick,
  backgroundColor = 'beige',
}) => {
  const Icon = () => icon
  const theme = useTheme()
  const { isMobileView } = useMediaContext()
  return (
    <SearchBarButtonTag
      className={selected ? 'selected' : ''}
      onClick={onClick}
      backgroundColor={backgroundColor}
    >
      <Icon />
      <span>
        {title}
        {selected && (
          <LibraryIcon
            aria-hidden
            icon="slice-curly-arrow-down"
            size={isMobileView ? '1.188rem' : '1.5rem'}
            color={theme.palette.brand.lightGreen}
          />
        )}
      </span>
    </SearchBarButtonTag>
  )
}
